import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// @ts-ignore
import ru from "./locales/ru.json";
// @ts-ignore
import kz from "./locales/kz.json";

i18n
    .use(LanguageDetector) // localStorage + navigator language
    .use(initReactI18next)
    .init({
        resources: { ru: { translation: ru }, kz: { translation: kz } },
        fallbackLng: "ru",
        interpolation: { escapeValue: false },
        detection: {
            // сохраняем выбор пользователя
            order: ["localStorage", "navigator", "htmlTag"],
            caches: ["localStorage"]
        },
        react: { useSuspense: false }
    });

export default i18n;
